"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTextVariant = getTextVariant;
exports.getTextAppearance = getTextAppearance;

var _mixin = require("../theme/mixin");

function getTextVariant(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'body' : _ref$variant;
  return {
    span: _mixin.Mixin.Font.bodyRegular(),
    small: _mixin.Mixin.Font.bodySmall(),
    code: _mixin.Mixin.Font.codeRegular(),
    body: _mixin.Mixin.Font.bodyRegular(),
    article: _mixin.Mixin.Font.articleRegular(),
    caption: _mixin.Mixin.Font.caption(),
    h6: _mixin.Mixin.Font.h6(),
    h5: _mixin.Mixin.Font.h5(),
    h4: _mixin.Mixin.Font.h4(),
    h3: _mixin.Mixin.Font.h3(),
    h2: _mixin.Mixin.Font.h2(),
    h1: _mixin.Mixin.Font.h1()
  }[variant];
}

function getTextAppearance(_ref2) {
  var _ref2$appearance = _ref2.appearance,
      appearance = _ref2$appearance === void 0 ? 'regular' : _ref2$appearance;
  return {
    regular: 'text-decoration: none;',
    bold: 'font-weight: 700;',
    italic: 'font-style: italic;',
    underlined: 'text-decoration: underline;'
  }[appearance];
}